import { useTranslation } from '@centric-os/helpers';
import { object, string, number } from 'yup';

export default () => {
  // Set localization
  const { translate } = useTranslation();

  const multigroupSchema = string().optional().nullable();

  const defaultSchema = object().shape({
    id: string().optional().nullable(),
    name: string().required(translate('errorMessages.required')),
    multigroup: multigroupSchema,
    label: object()
      .shape({
        en: string().optional().nullable(),
      })
      .optional(),
    address: object().shape({
      state: string().required(translate('errorMessages.required')),
      zip: string().required(translate('errorMessages.required')),
      country: string().required(translate('errorMessages.required')),
      address: string().required(translate('errorMessages.required')),
      city: string().required(translate('errorMessages.required')),
      coordinates: object().shape({
        latitude: number().required(translate('errorMessages.required')),
        longitude: number().required(translate('errorMessages.required')),
      }),
    }),
    meta: object().shape({
      sector_name: string().required(translate('errorMessages.required')),
    }),
  });

  return {
    defaultSchema,
  };
};
